import $api from 'http'
import $apiJSON from 'http/apiJSON'

// ── Employee selector ─────────────────────────────────────────────────────────
export const getDocflowEmployees = () =>
  $apiJSON.get('docflow/employees/')

// ── Document lists ────────────────────────────────────────────────────────────
export const getInbox   = () => $apiJSON.get('docflow/inbox/')
export const getOutbox  = () => $apiJSON.get('docflow/outbox/')
export const getHistory = () => $apiJSON.get('docflow/history/')

// ── Document CRUD ─────────────────────────────────────────────────────────────
export const getDocument = (id) =>
  $apiJSON.get(`docflow/documents/${id}/`)

export const createDocument = (formData) =>
  $api.post('docflow/documents/', formData, { headers: { 'Content-Type': undefined } })

export const updateDocument = (id, formData) =>
  $api.patch(`docflow/documents/${id}/`, formData, { headers: { 'Content-Type': undefined } })

// ── Workflow ──────────────────────────────────────────────────────────────────
export const signDocument   = (id)         => $apiJSON.post(`docflow/documents/${id}/sign/`)
export const returnDocument = (id, reason) => $apiJSON.post(`docflow/documents/${id}/return/`, { reason })
export const cancelDocument = (id)         => $apiJSON.post(`docflow/documents/${id}/cancel/`)
export const markDocRead    = (id)         => $apiJSON.post(`docflow/documents/${id}/mark-read/`)

// ── Comments ──────────────────────────────────────────────────────────────────
export const addComment    = (docId, text) => $apiJSON.post(`docflow/documents/${docId}/comments/`, { text })
export const deleteComment = (id)          => $apiJSON.delete(`docflow/comments/${id}/`)

// ── Attachments ───────────────────────────────────────────────────────────────
export const addAttachment = (docId, formData) =>
  $api.post(`docflow/documents/${docId}/attachments/`, formData, { headers: { 'Content-Type': undefined } })

export const deleteAttachment = (id) =>
  $apiJSON.delete(`docflow/attachments/${id}/`)

// ── Acquaintance ──────────────────────────────────────────────────────────────
export const sendAcquaintance    = (docId, data) =>
  $apiJSON.post(`docflow/documents/${docId}/acquaintance/`, data)

export const markAcquaintanceRead = (docId) =>
  $apiJSON.post(`docflow/documents/${docId}/acquaintance/read/`)
